<template>
  <div id="app">
    <el-container class="index-con" v-if="!isShow()">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-header class="index-header">
          <navcon></navcon>
        </el-header>
        <keep-alive> <router-view class="index-main"></router-view></keep-alive>
      </el-container>
    </el-container>
    <router-view class="index-main" v-else></router-view>
  </div>
</template>

<script>
import navcon from "./components/navcon.vue";
import leftnav from "./components/leftnav.vue";
export default {
  name: "APP",
  data() {
    return {
      showclass: "asideshow",
      showtype: false
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {
    isShow() {
      return this.$route.path == "/login";
    }
  },
  created() {
    // 监听
    this.$root.Bus.$on("toggle", value => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.index-header {
  padding: 0px;
  border-left: 2px solid #333;
}

.index-main {
  padding: 20px;
  flex: 1;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue